module.exports = __webpack_public_path__ + "img/select.94ccef64.png";